'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _MedicalCodesTable = require('../MedicalCodesTable');

var _MedicalCodesTable2 = _interopRequireDefault(_MedicalCodesTable);

var _FormModal = require('../../../lib/mighty-fields/FormModal');

var _FormModal2 = _interopRequireDefault(_FormModal);

var _AppConstants = require('../../../constants/AppConstants');

var _AppConstants2 = _interopRequireDefault(_AppConstants);

var _FieldSets = require('./FieldSets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var APPLICATION_MODELS = _AppConstants2.default.APPLICATION_MODELS;
var FinalizeMedicalApplicationModal = (_dec = (0, _mobxReact.inject)('ApplicationStore', 'FunderStore', 'LienStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(FinalizeMedicalApplicationModal, _Component);

  function FinalizeMedicalApplicationModal() {
    _classCallCheck(this, FinalizeMedicalApplicationModal);

    return _possibleConstructorReturn(this, (FinalizeMedicalApplicationModal.__proto__ || Object.getPrototypeOf(FinalizeMedicalApplicationModal)).apply(this, arguments));
  }

  _createClass(FinalizeMedicalApplicationModal, [{
    key: 'onSave',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formData) {
        var _props, application, ApplicationStore, caseId, lien, LienStore, onClose, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, application = _props.application, ApplicationStore = _props.ApplicationStore, caseId = _props.caseId, lien = _props.lien, LienStore = _props.LienStore, onClose = _props.onClose, data = _extends({}, application, {
                  lien: _extends({}, lien.serialize(), formData),
                  status: 'funded',
                  transitions: [{
                    note: '',
                    reason: null,
                    status_after: 'funded',
                    status_before: application.status
                  }]
                });
                _context.next = 3;
                return ApplicationStore.update({ application: application, data: data, type: APPLICATION_MODELS.MEDICAL.model });

              case 3:
                LienStore.list({ caseId: caseId });
                onClose();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSave(_x) {
        return _ref.apply(this, arguments);
      }

      return onSave;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$FunderStore = _props2.FunderStore,
          isFinanceCustomer = _props2$FunderStore.isFinanceCustomer,
          isMedicalProvider = _props2$FunderStore.isMedicalProvider,
          lien = _props2.lien,
          onClose = _props2.onClose,
          lienData = _extends({}, lien, { medical_code: (0, _get3.default)(lien, 'codes[0].medical_code') });

      return _react2.default.createElement(
        _FormModal2.default,
        {
          fieldSets: (0, _FieldSets.fieldSetsMedicalApplication)({
            finalize: true,
            isFinanceCustomer: isFinanceCustomer,
            isMedicalProvider: isMedicalProvider
          }),
          model: lienData,
          onClose: onClose,
          onSave: this.onSave,
          title: 'Finalize Medical Funding Application'
        },
        _react2.default.createElement(_MedicalCodesTable2.default, {
          lien: (0, _mobx.toJS)(lien),
          canAddMedicalCodes: false,
          canDeleteMedicalCodes: false,
          medicalCodes: (0, _mobx.toJS)(lien.codes) || []
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return FinalizeMedicalApplicationModal;
}(_react.Component), _class2.propTypes = {
  application: _propTypes2.default.object.isRequired,
  ApplicationStore: _propTypes2.default.object.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  lien: _propTypes2.default.object.isRequired,
  LienStore: _propTypes2.default.object.isRequired,
  onClose: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = FinalizeMedicalApplicationModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(APPLICATION_MODELS, 'APPLICATION_MODELS', '/app/src/components/page-case/main-applications/FinalizeMedicalApplicationModal.js');
  reactHotLoader.register(FinalizeMedicalApplicationModal, 'FinalizeMedicalApplicationModal', '/app/src/components/page-case/main-applications/FinalizeMedicalApplicationModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-applications/FinalizeMedicalApplicationModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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